import { VideoStyleStrategy } from './video-style-strategy';

export class MediumRectangleVideoStyleStrategy extends VideoStyleStrategy {
  protected getVideoContainerStyle(): Record<string, string | number> {
    return {
      position: 'relative',
      top: 41,
      width: 'auto',
      height: this.videoStore.windowSize.value.width * (9 / 16)
    };
  }
}
